import React from "react";
import "./Hero.css";
import { useLanguage } from "../context/LanguageContext";

const Hero = () => {
  const { t, language } = useLanguage();
  const sep = language === "ar" ? "، " : ", ";

  const scrollToContact = () => {
    const element = document.getElementById("contact");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="hero" className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              {t.hero.title} <span className="highlight">{t.hero.titleHighlight1}</span>
              {sep}
              <span className="highlight">{t.hero.titleHighlight2}</span>
              {sep}
              <span className="highlight">{t.hero.titleHighlight3}</span>
            </h1>
            <p className="hero-tagline">{t.hero.tagline}</p>
            <button type="button" className="cta-button" onClick={scrollToContact}>
              {t.hero.cta}
              <i className={`fas fa-arrow-${language === "ar" ? "left" : "right"}`} />
            </button>
          </div>
          <div className="hero-visual">
            <div className="hero-brand-panel" aria-hidden="true">
              <div className="hero-brand-ring" />
              <div className="hero-brand-glow" />
              <img src="/logo.png" alt="" className="hero-brand-logo" width={280} height={280} />
            </div>
          </div>
        </div>
      </div>
      <div className="hero-wave">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path
            d="M0,0 C300,120 600,0 900,60 C1050,90 1125,75 1200,60 L1200,120 L0,120 Z"
            fill="var(--bg-light)"
          />
        </svg>
      </div>
    </section>
  );
};

export default Hero;
